<template>
    <div>
        <div class="text-center">
            <h5>Antalya çıkışlı</h5>
            <h3 class="strong"><b>Popüler Destinasyonlar</b></h3>
        </div>
        <vueper-slides class="no-shadow d-none d-md-block d-lg-block" :visible-slides="3" :slide-ratio="1/4" :dragging-distance="70" fixed-height="450px">
            <vueper-slide v-for="(slide, index) in slides" :key="index">
                <div class="card" slot="slideContent">
                    <img class="card-img-top" :src=slide.cover alt="Card image cap">
                    <div class="card-body">
                        <div class="">{{slide.to_city_name}}, {{slide.to_country_name}}</div>
                        <div class="card-text small">
                            {{slide.from_city_name}} ({{slide.from_code}}) - {{slide.to_city_name}} ({{slide.to_code}})
                        </div>
                        <div class="card-text small">
                            {{slide.date_label}}
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="">
                                    <div class="price">{{slide.price+currency[slide.currency_id-1]}}</div>
                                    <div class="small grey-text">{{slide.transfer}}</div>
                                </div>
                            </div>
                            <div class="col-6">
                                <a class="btn biletbul-bg-blue btn-sm waves-effect waves-light" :href="slide.url">Detaylar <mdb-icon icon="angle-double-right" /></a>
                            </div>
                        </div>

                    </div>
                </div>
            </vueper-slide>
        </vueper-slides>

    </div>
</template>

<script>
    import axios from "axios";
    import { mdbIcon, mdbCard } from 'mdbvue';
    import { VueperSlides, VueperSlide } from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'

    export default {
        name: "centerSlide.vue",
        components: {
            mdbCard,mdbIcon,
            VueperSlides, VueperSlide,
        },
        data: () => ({
            title:'Yurt Dışı En Uygun Uçak Biletleri',
            remoteUrl:'https://www.biletbul.com/biletbul/backend/public',
            icon:'chevron-right',
            currency : ['₺','$','€'],
        slides : [
            /*{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',
                image: require('../assets/images/Mask_Group_2.png')
            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',
                image: require('../assets/images/Mask_Group_3.png')
            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',
                image: require('../assets/images/Mask_Group_4.png')
            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',
                image: require('../assets/images/Mask_Group_4.png')
            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',
                image: require('../assets/images/Mask_Group_4.png')
            },*/
        ],
        }),
        mounted() {

            axios.get("https://www.biletbul.com/backend/public/api/v1/destination/category/3",{
                headers: {

                }
            })
                .then(response => this.slides=[...response.data.data])
        }
    }
</script>

<style scoped>

</style>
